module.exports = __webpack_public_path__ + "img/passeport.0b91f133.svg";